import React from "react";

const Party = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>Party</h2>
        <p>Content for Party page will go here.</p>
      </div>
    </div>
  );
};

export default Party;
